import React, { useEffect } from "react";
import { bomPassTest } from "../../admin/DebugTools";

function useBomTest({ user, app, bomTestResult, setBomTestResult }) {
    useEffect(() => {
        if (window.location.href.includes("bom-auto-test") && user?.Role === 99) {
            if (bomTestResult === "STARTING UP") {
                setBomTestResult("LOADING ...");

                bomPassTest({ app, user }).then((testResult) => {
                    const resultElement = testResult ? "PASSED" : "FAILED";
                    setBomTestResult(resultElement);
                });
            }
        }
        if (window.location.href.includes("load-bom-auto-test") && user?.Role === 99) {
            if (bomTestResult === "STARTING UP") {
                setBomTestResult("LOADING ...");

                bomPassTest({ app, user }).then((testResult) => {
                    const resultElement = testResult ? "PASSED" : "FAILED";
                    setBomTestResult(resultElement);
                });
            }
        }
    }, [user, app]);
}

export default useBomTest;
